class redirectionPopUp extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const res = await fetch("https://1.1.1.1/cdn-cgi/trace");
    const data = await res.text();
    const dataObj = Object.fromEntries(
      data
        .trim()
        .split("\n")
        .map((e) => e.split("="))
    );
    if (dataObj.loc === "EG") return;
    this.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    this.querySelector("button").addEventListener("click", () => {
      const newURL = window.location.href.replace(
        "bypavo.com",
        "sa.bypavo.com"
      );
      window.location.replace(newURL);
    });
  }
}

customElements.define("redirection-popup", redirectionPopUp);
